import { useTranslation } from "@hireroo/i18n";
import * as React from "react";

import { InputControlTextFieldProps } from "../../../../legacy/primitive/InputControl/InputControlTextField";
import ResourceFieldV2 from "../../../../modules/ResourceFieldV2/ResourceFieldV2";
import InputControlTextField from "../../../../primitive/InputControl/InputControlTextField/InputControlTextField";

export type DisplayNameFieldProps = Pick<InputControlTextFieldProps, "sx">;

const DisplayNameField: React.FC<DisplayNameFieldProps> = props => {
  const { t } = useTranslation();
  return (
    <ResourceFieldV2 label={t("あなたの氏名")} kind="REQUIRED" formLabel={{ sx: { fontWeight: 700, fontSize: 14, marginBottom: 1.5 } }}>
      <InputControlTextField name="displayName" {...props} />
    </ResourceFieldV2>
  );
};

DisplayNameField.displayName = "DisplayNameField";

export default DisplayNameField;
